import { Box } from '@mui/material'

import { IGroupEntity } from '../../models/IGroup'

import { useNavigate } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'
import { CardStandart } from 'ui/CardStandart'
import GroupBarn from './GroupBarn'
import GroupInfo from './GroupInfo'
import { DigitizationsIndicators } from './ui/digitization-indicators/DigitizationsIndicators'
import { ExpiredLicense } from './ui/expired-license/ExpiredLicense'
import { FoodTableIndicators } from './ui/food-table-indicators/FoodTableIndicators'
import { LinearChart } from './ui/linear-chart/LinearChart'

type GroupItemProps = IGroupEntity & {
	hasFoodTableLicense?: boolean
}

const GroupItem = (props: GroupItemProps) => {
	const { hasFoodTableLicense = false, ...group } = props
	const navigate = useNavigate()
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	const showKsInfo = Boolean(
		permissions?.license_food_table && hasFoodTableLicense,
	)
	const isExpiredAllLicense =
		userData?.isFatnessExpired &&
		userData?.isFoodTableExpired &&
		userData?.isIdentificationExpired &&
		userData?.isLamenessExpired
	return (
		<CardStandart
			onClick={() => navigate(`/feed/groups/${group.groupkey.toString()}`)}
			sx={{
				padding: '24px',
				width: '100%',
				height: 'auto',
				cursor: 'pointer',
			}}
		>
			<Box
				display={'flex'}
				flexDirection={'column'}
				justifyContent={'space-between'}
				gap={'24px'}
			>
				<GroupBarn {...group} />
				{isExpiredAllLicense ? (
					<ExpiredLicense mt={'50px'} />
				) : (
					<>
						<GroupInfo {...group} hasFoodTableLicense={hasFoodTableLicense} />
						{(permissions?.license_identification ||
							permissions?.license_fatness ||
							permissions?.license_limpness) && (
							<DigitizationsIndicators {...group} />
						)}
						{showKsInfo && (
							<>
								<FoodTableIndicators {...group} />
								{userData?.isFoodTableExpired ? null : (
									<LinearChart {...group} />
								)}
							</>
						)}
					</>
				)}
			</Box>
		</CardStandart>
	)
}

export default GroupItem
